import React, { FC } from 'react';
import { Category } from 'shared/types/product/Category';
import Link from 'components/commercetools-ui/atoms/link';
import Typography from 'components/commercetools-ui/atoms/typography';
import { useFormat } from 'helpers/hooks/useFormat';
import MobileMenuNavButton from '../atoms/menu-nav-button';
import { ArrowLeftIcon, PhoneIcon} from '@heroicons/react/24/solid';

export interface Props {
  links: any[];
  topRightMenu:any;
  topCentreMenu:any;
  hideHeaderMenu: () => void;
  onArrowClick: () => void;
  categoriesNavigator?: any[]; //This is a navigator where you push a subcategory to show it's contents
  insertCategory: (category: Category) => void;
}

const MobileMenu: FC<Props> = ({ links, topRightMenu, topCentreMenu, categoriesNavigator, insertCategory, hideHeaderMenu, onArrowClick }) => {
  const { formatMessage } = useFormat({ name: 'common' });

  return (
    <div className="h-full bg-[#F3EDE9] overflow-y-auto pb-48">
        {categoriesNavigator && categoriesNavigator.length <= 0 ? (
        <>
          {links?.map((link) => (
            <MobileMenuNavButton
              key={link?.label}
              categoriesNavigator={categoriesNavigator}
              link={link}
              onClick={() => insertCategory(link)}
              hideHeaderMenu={hideHeaderMenu}
            />
          ))}

          {topCentreMenu &&
             topCentreMenu.slice().reverse().map((link:any) => (
              <Link 
              key={link.menu_links.title} 
              link={link.menu_links.href} 
              onClick={hideHeaderMenu} 
              className="flex justify-between border-b-2 border-white" rel="noopener noreferrer">
                <span className="px-48 py-14 text-20 font-semibold text-primary-black relative">
                  {(link.menu_links.title === '13 14 16' || link.menu_links.title === '0800 804 222') ? (
                    <div>
                      <PhoneIcon className="ml-3 mt-1 w-16 text-black" style={{ float: 'left', marginTop: '5px', marginRight: '10px' }} /><span className="ml-2 text-black">{link.menu_links.title}</span>
                    </div>
                  ) : (
                    <span className="ml-2 text-black">{link.menu_links.title}</span>
                  )}
                </span>
          </Link>            
           )
           )}

          {topRightMenu &&
            topRightMenu.slice().reverse().map((link:any) => (
            <Link key={link.menu_links.title} link={link.menu_links.href} onClick={hideHeaderMenu} className="flex justify-between border-b-2 border-white" rel="noopener noreferrer" target="_blank">
              <Typography className="px-48 py-14 text-20 font-semibold text-primary-black relative">
              {link.menu_links.title}
              </Typography>
            </Link>
            )
          )}
        </>
      ) : (
        <>
          {categoriesNavigator && (
              <div onClick={onArrowClick}  className="flex items-center gap-8 bg-[#2B2C39] px-16 py-14">
              <Link className="flex gap-8">
              <ArrowLeftIcon className="w-24 text-white"/>
                  <Typography className="text-20  font-semibold text-white">
                  {categoriesNavigator[categoriesNavigator.length - 1]?.label}
                  </Typography>
              </Link>
            </div>
          )}

          {categoriesNavigator &&
              categoriesNavigator[categoriesNavigator.length - 1]?.mega_menu?.submenu_links?.map((nav: any) => (
                <MobileMenuNavButton
                key={nav?.title}
                categoriesNavigator={categoriesNavigator}
                link={nav}
                onClick={() => insertCategory(nav)}
                hideHeaderMenu={hideHeaderMenu}
                />
            ))}
        </>
      )}
    </div>
  );
};

export default MobileMenu;
